module.exports = __webpack_public_path__ + "static/media/whatsapp-logo.aede9fa5.svg";